import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ContactDetails() {
  const contactInfo = [{
    icon: MapPin,
    title: "Visit Us",
    details: "2512 North 500 East Vernal, Utah 84078",
    link: "https://maps.google.com/?q=1234+Lilac+Avenue,+Suite+567,+YourCity,+YourState,+ZIP",
    linkText: "Get Directions",
    newTab: true
  }, {
    icon: Phone,
    title: "Call Us",
    details: "(435) 790 - 4987",
    link: "tel:+15559876543",
    linkText: "Call Now",
    newTab: false
  }, {
    icon: Mail,
    title: "Email Us",
    details: "dianacook@icloud.com",
    link: "mailto:info@cobrnik.com",
    linkText: "Send a Message",
    newTab: false
  }];
  return <section id="contact-details" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-accent/50 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-stretch">
          
          {}
          <div className="flex flex-col justify-center space-y-10">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-serif text-foreground tracking-tight">
                Get in Touch
              </h2>
              <p className="text-lg text-muted-foreground font-sans max-w-lg leading-relaxed">
                We welcome inquiries from prospective families. Whether you have questions about our breeding program, upcoming litters, or the Cavalier breed, please reach out.
              </p>
            </div>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1">
              {contactInfo.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-5 p-6 rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 shadow-sm hover:shadow-md hover:bg-card transition-all duration-300 group">
                  <div className="p-3 rounded-xl bg-background shadow-sm border border-border/50 text-chart-4 group-hover:scale-110 transition-transform duration-300">
                    <item.icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                  <div className="space-y-1.5 flex-1">
                    <h3 className="font-serif text-xl text-foreground font-medium">
                      {item.title}
                    </h3>
                    <p className="text-muted-foreground whitespace-pre-line font-sans text-sm leading-relaxed">
                      {item.details}
                    </p>
                    {item.link && <div className="pt-2">
                        
                      </div>}
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="relative h-full min-h-[400px] lg:min-h-[600px] rounded-3xl overflow-hidden shadow-xl border border-border/50 group">
            <img src="https://brave-rhino.10web.cloud/wp-content/uploads/2026/04/Contact-cavaliers-scaled.jpeg" alt="Cobrnik Cavaliers Kennel Grounds" className="absolute inset-0 h-full object-cover transition-transform duration-1000 group-hover:scale-105 !w-[600px]" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent pointer-events-none" />
            
            {}
            <div className="absolute bottom-6 left-6 right-6 sm:bottom-8 sm:left-8 sm:right-8">
               
            </div>
          </div>

        </div>
      </div>
    </section>;
}